import TldrPodcast from "@/components/shadcn/_custom/tldr-podcast";
import {absoluteURL} from "@/lib/absolute-url";

export function ParagraphPodcast({paragraph, ...props}) {
  const audioUrl = paragraph?.field_podcast_podcast?.field_media_file?.uri?.url;
  const image = paragraph?.field_podcast_podcast?.field_podcast_image;
  return (
    <>
      {(audioUrl && image?.image?.uri?.url) && (
        <TldrPodcast title={paragraph.field_podcast_podcast.field_podcast_title}
                     description={paragraph.field_podcast_podcast.field_podcast_description}
                     category={paragraph.field_podcast_podcast?.field_podcast_category}
                     coverImage={image}
                     audioSource={`${absoluteURL(audioUrl)}`} />
      )}
    </>
  )
}